// strings.js

const strings = {
    STRIPE_DEV_PRODUCT_PAYMENT_URL: "https://buy.stripe.com/test_cN24hj4gZ5pv9CE6p3", // facea
    STRIPE_PROD_PRODUCT_PAYMENT_URL: "https://buy.stripe.com/fZefZR1x49VA7MQ7t6", // facea

    STRIPE_SUBSCRIPTION_MANAGEMENT_URL: "https://billing.stripe.com/p/login/28ocP200L31J9gs7ss",
    SUBSCRIPTION_STATUS_API_URL: "https://funquiz.app/modular2/subscription-status",
    
    GENERIC_PAGE_TITLE: "Face Attributes Editior 😃",
    HOME_PAGE_TITLE: "Home - Face Attributes Editior 😃",
    DASHBOARD_PAGE_TITLE: "Home - Face Attributes Editior 😃",
    WELCOME_MESSAGE_H1_TITLE: "Welcome to Face Attributes Editior 😃",
    FX_DESCRIPTION_MESSAGE: "This f(x) can be used to edit image face attributes, choose an image and then press the 'Submit Input' button below to get your result!",
    
    MAIN_API_NAME: "face_atts_edit_ai_1",
    MAIN_API_URL: "https://funquiz.app/modular2/face-atts-ai-1",

    PROD_CLERK_PUB_KEY: "pk_live_Y2xlcmsueW9sbGVnLmNvbSQ",
    DEV_CLERK_PUB_KEY: "pk_test_aGFybWxlc3MtYmVlLTY5LmNsZXJrLmFjY291bnRzLmRldiQ",

    // ... add more strings as needed
};



export default strings;